import { generateTestId } from "@client-shared";

export const setOrderDetailDialogTestId = (identifier: string): string =>
  generateTestId("OrderDetailDialog", identifier);
